import { ErrorHandler, Injectable } from "@angular/core";
import { LogingService } from "../_services/loging.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private loggingService: LogingService) {
        super();
    }

    handleError(error: Error) {
        this.loggingService.logException(error);
    }
}